import baseAPI from '@/api/base';
import {
  EditEmployeeOffboardingTemplate,
  GetEmployeeOffboardingTemplate,
  RegisterEmployeeOffboardingTemplate,
} from '@/dtos/employee_offboarding_template.dto';
import {
  DELETE_EMPLOYEE_OFFBOARDING_TEMPLATE_URL,
  EDIT_EMPLOYEE_OFFBOARDING_TEMPLATE_URL,
  GET_EMPLOYEE_OFFBOARDING_TEMPLATE_URL,
  REGISTER_EMPLOYEE_OFFBOARDING_TEMPLATE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeOffboardingTemplate {
  static getEmployeeOffboardingTemplates = async (
    params: GetEmployeeOffboardingTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_OFFBOARDING_TEMPLATE_URL, {
      params,
    });
    return response;
  };

  static registerEmployeeOffboardingTemplate = async (
    payload: RegisterEmployeeOffboardingTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_OFFBOARDING_TEMPLATE_URL, {
      ...payload,
    });
    return response;
  };

  static editEmployeeOffboardingTemplate = async (
    payload: EditEmployeeOffboardingTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_OFFBOARDING_TEMPLATE_URL, {
      ...payload,
    });
    return response;
  };

  static deleteEmployeeOffboardingTemplate = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_OFFBOARDING_TEMPLATE_URL}/${id}`
    );
    return response;
  };
}

export default EmployeeOffboardingTemplate;
